import pin from '../../assets/images/pin.png';
import santorini from '../../assets/images/santorini.jpg';
import milos from '../../assets/images/milos.jpg';
import athens from '../../assets/images/athens.jpg';
import meteora from '../../assets/images/meteora.jpg';
import london from '../../assets/images/london.jpg';
import { Coords } from '../Resume/Experience';

export type Destination = {
        id: number,
        length: number;
        city?: string;
        region: string;
        country: string;
        coords: Coords;
        destImg?: any;
        highlights: string[];
}
export type Trip = {
    name: string;
    start: Date;
    end: Date;
    destinations: Destination[];
    coverImg: any;
};

export const trips: Trip[] = [
    {
        start: new Date(2024, 5),
        end: new Date(2024, 5),
        name: "Greece and London",
        destinations: [
            {
                id: 1,
                length: 4,
                region: "Santorini",
                country: "Greece",
                coords: { lat: 36.4613, lon: 25.3751 },
                highlights: [
                    "Explored the picturesque streets of Oia.",
                    "Stayed in a cave on the clifs of Imerovigli.",
                    "Enjoyed the local cuisine and wine.",
                    "Visited the ancient ruins of Akrotiri.",
                    "Enjoyed local beer and the Ftelos brewery.",
                ],
                destImg: santorini,
            },
            {
                id: 2,
                length: 7,
                region: "Milos",
                country: "Greece",
                coords: { lat: 36.7241, lon: 24.4444 },
                highlights: [
                    "Explored the beaches and geological wonders of Sarakiniko.",
                    "Visited the catacombs and ancient ruins of Milos.",
                    "Enjoyed the local seafood and wine.",
                    "Adventured to the majestic ladder beach of Tsigadro",
                ],
                destImg: milos,
            },
            {
                id: 3,
                length: 4,
                city: "Athens",
                region: "Athens",
                country: "Greece",
                coords: { lat: 37.9715, lon: 23.7257 },
                highlights: [
                    "Visited the Acropolis and Parthenon.",
                    "Explored the Plaka district and Monastiraki.",
                    "Enjoyed a phenomenal view of Acropolis Hill from the rooftop bar of A for Athens.",
                    "Visited the ancient ruins of the Agora.",
                ],
                destImg: athens,
            },
            {
                id: 4,
                length: 1,
                region: "Meteora",
                country: "Greece",
                coords: { lat: 39.7212, lon: 21.6304 },
                highlights: [
                    "Visited the monasteries of Meteora.",
                    "Explored the monasteries of Varlaam and Great Meteoron.",
                    "Enjoyed the views of the monasteries from the town of Kalambaka.",
                ],
                destImg: meteora,
            },
            {
                id: 5,
                length: 4,
                city: "London",
                region: "England",
                country: "United Kingdom",
                coords: { lat: 51.4995, lon: -0.1248 },
                highlights: [
                    "Took pictures from the London Eye.",
                    "Explored the historic streets of London.",
                    "Enjoyed the local cuisine and beer.",
                    "Did some shopping.",
                ],
                destImg: london,
            },
        ],
        coverImg: pin,
    },
];

